// == Description
// This is used on PercentageAnswer questions that collect percentages of trades
// or types of work for spit-rating (currently only used on USA carriers).
// The question asks what percentage out of 100% is each trade or type of work
//
// == Behavior
//  Total percentage is updated dynamically as user enters % for each item.
//  Display a message that tells user total percentage doesn't add up to 100%.
//  Message disappears when all trades have % and total is 100%.

// remove server rendered trade ratio error message so user only sees one
const removeRedundantError = (questionSelector) => {
  const hyphenatedQuestionSelector = questionSelector.replace(/_/g, "-");
  const redundantError =
    $(
      `[data-question="${questionSelector}"] span.error#${hyphenatedQuestionSelector}-error`,
    ).html() ===
    "Must add up to 100%. Please only use whole numbers greater than 0.";

  if (redundantError) {
    $(
      `[data-question="${questionSelector}"] span.error#${hyphenatedQuestionSelector}-error`,
    ).remove();
  }
};

const handlePercentageAnswer = (questionSelector) => () => {
  let totalSum = 0;
  const tradePercentages = Array.from(
    $(
      `[data-question="${questionSelector}"] .percentage-row .ratio-percentage`,
    ),
  ).map((percentage) => percentage.value);

  const greaterThanZero = (val) => Number(val) > 0;

  tradePercentages.forEach((percentage) => {
    if ($.isNumeric(percentage)) {
      totalSum += parseFloat(percentage);
    }
  });

  $(`[data-question="${questionSelector}"] #total-percentage`).val(
    `${totalSum}%`,
  );

  removeRedundantError(questionSelector);

  const noZeroPercentages = tradePercentages.every(greaterThanZero);
  const emptyPercentages = tradePercentages.filter(
    (percentage) => percentage === "",
  ).length;

  if (emptyPercentages === 0) {
    if (noZeroPercentages && totalSum === 100) {
      $(`[data-question="${questionSelector}"] span#too-high`).hide();
    } else {
      $(`[data-question="${questionSelector}"] span#too-high`).show();
    }
  }
};

(function ($) {
  $(document).ready(() => {
    [
      "interior_and_exterior_ratio",
      "trade_ratio",
      "residential_and_commercial_ratio",
    ].forEach((questionSelector) => {
      $(`[data-question="${questionSelector}"]`).on(
        "input",
        ".ratio-percentage",
        handlePercentageAnswer(questionSelector),
      );
    });
  });
})(window.jQuery);
